import { setCookie,getCookie, deleteCookie } from "cookies-next";
import { createCustomerAsscoation, createCustomerShippingAsscoation, generateMultiPassURL } from "@/helpers/userHelpers";
//OS-4874 createCart checkout introduced
import { createCartCheckout } from "@/helpers/cartHelpers";
import { useSelector } from "react-redux";
import { useRouter } from "next/compat/router";
import { useDispatch } from "react-redux";

import { getDiscountData } from "@/helpers/customerDiscount";
import styles from "../CheckoutButton/CheckoutButton.module.scss";
import { useEffect, useState } from "react";
import { generalConstants } from "@/utils/constants";
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { checkNostoForCart } from "../Nosto";
import InstallmentMsg from "../InstallmentMsgComp";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { setEstimatedShip } from "@/helpers/checkout-shipping/checkoutShippingHelper";
import { detectIncognito } from "detectincognitojs"
export default function CheckoutButton({ href, checkoutText, className, isOnlyOOS, showPaymentIcons}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  // href = href.replace(process.env.SHOPIFY_STORE_DOMAIN, process.env.SHOPIFY_CHECKOUT_URL);
  const isUserLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  let logUser = useSelector((state) => state.loginUser);
  const router = useRouter();
  const userData = useSelector((state) => state.loginUser.userData?.tags);
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);
  const isMobile = useMediaQuery("(max-width: 767px)");

  // let userSegmentCheck;
  // if(userData?.includes("fall25code")){
  //   userSegmentCheck = "fall";
  // } else 
  // if(userData?.includes("dec-promo")) {
  //   userSegmentCheck = "exclusive";
  // } 
  // else {
  //   userSegmentCheck = "exclusive";
  // }
  const [loading,setLoading] = useState(false);
  let [rewardDiscountCode, setRewardDiscountCode] = useState(null);
  useEffect(() => {
    async function fetchMyAPI() {
      //let res = await getDiscountData(userSegmentCheck);
      let res = false;
      setRewardDiscountCode(res);
    }
    fetchMyAPI();
  }, []);
  const findDiscount = () => {
    let discountData = rewardDiscountCode;
    if (!discountData) {
      return;
    } 
    else {
      return;
    }
    //check for fall150credit or fall25code - true or false
    const discountCookiePresent = getCookie(generalConstants.user_discount_tag) || getCookie(generalConstants.user_discount_tag2);
    const discountTagPresent = discountCookiePresent;
    if (!discountTagPresent) {
      return false;
    }
    let cartTotal;
    try {
      if (cart_list.totalPrice) {
        cartTotal = cart_list.subtotalPrice;
      }
      else {
        cartTotal = cart_list.estimatedCost?.subtotalAmount?.amount;
      }
      cartTotal = Number(cartTotal);
      let foundCode = discountData.find(discount => {
        if (cartTotal > discount.cartValue) {
          return discount;
        }
      });
      if (foundCode) {
        return foundCode.title;
      }
      return false;
    }
    catch (e) {
      console.error(e);
      return false;
    }
  }

  const dispatch = useDispatch();
  const handleClick = async () => {
    //variable to keep a track of incognito tab
    let isIncognito = false;
    if(localStorage.getItem('klaviyo_external_profile_id')) {
      localStorage.setItem('klaviyo_external_profile_id','');
    }

    //function to detect browser incognito
    await detectIncognito().then((result) => {
      if(result?.isPrivate){
        isIncognito = true;
      }
    });

    let isRecommendationsPageSeen = getCookie("recommendations_page_seen");
    let cartTotal = cart_list?.subtotalPrice ? cart_list.subtotalPrice : cart_list.estimatedCost?.subtotalAmount?.amount;
      /**
         * User visited checkout shopify page
         * Remove cart items from local
         */
      setLoading(true);
      var items = [];
      //OS-4874 removed code of going through attributes
      let checkoutId = cart_list.id;
      let buyerIdentity = {};
      //OS-4874 only if the user is logged in then below function will be needed to link cart with the customer
      if (logUser?.user_loggedIn?.accessToken) {
        buyerIdentity = {
          "customerAccessToken": logUser?.user_loggedIn?.accessToken,
          "email": logUser?.userData?.email,
        }
        
      }
      //OS-4874 to the current cart list above cart line attributes an dif the user is logged in will be linked
      var checkoutRes = await createCartCheckout(cart_list,items,buyerIdentity, isIncognito);
      href = checkoutRes.checkoutUrl;
      checkoutId = checkoutRes.id;

      setCookie('cookie_present', 'checkout')
      // setCookie('new_checkoutId', checkoutRes.id);
      // setCookie('compareCheckout', true);
      deleteCookie("cart_updated");
      //OS-4874 in the checkoutUrl we get teh final checkout url for the user to redirect

      //logging to check checkout is duplicate or not
      reportError("duplicate checkout",checkoutId);
      //OS-4874 now we do not get checkout id but cart id in return
      window?.ReactNativeWebView?.postMessage(JSON.stringify({ externalLink: true, link: `${href}`}))
      let foundDiscount = findDiscount();
      if (foundDiscount)
        href = `${href}&discount=${foundDiscount}`;
      let click_id = getCookie("utm_clickId");
      if (typeof click_id !== "undefined" && click_id != "")
        href = `${href}&clickid=${click_id}`;

       //to auto login teh user at checkout multipass url is required 
      if (logUser?.user_loggedIn?.accessToken) {
        var multiPassURL = await generateMultiPassURL({
          token: logUser.user_loggedIn.accessToken,
          url: href
        });

        if (multiPassURL.url) {
          setCookie('ab_test_checkout', multiPassURL.url);
        }
      } else {
        setCookie('ab_test_checkout', href);
      }  
  
      //OS-4874 now we do not need to link the customer n its address with cart separately, we can directly link it in cartCreate 
    if (!(typeof isRecommendationsPageSeen != "undefined" && isRecommendationsPageSeen) && Number(cartTotal) < generalConstants.RECOMMENDATION_THRESHOLD) {
      //show recommendations page only once per session
      setLoading(false);
      dispatch(openMiniCart(false));
      setCookie("recommendations_page_seen", true)
      isPWAApp ? window.location.href='/recommended-for-you' : router.push('/recommended-for-you');
    }
    else {
      if (typeof checkoutId !== "undefined" && checkoutId != "" && isUserLoggedIn) {
        /* To login customer in the Shopify env */
        if (logUser?.user_loggedIn?.accessToken) {
          if (multiPassURL.url) {
            setLoading(false);
            router.push(multiPassURL.url);
            return;
          }
        }
        setLoading(false);
        router.push(href);
      }
      else {
        router.push(href);
      }
      setLoading(false);
    }
  }

  return (
    <>
      {/* If button should link somewhere*/}
      {href && (
        <><button id="checkoutButton" tabIndex={0} className={`btn-primary ${styles.checkout_btn} ${loading ? ' loading':''} ${isOnlyOOS ? 'disabled' : ''}`} onClick={() => handleClick()}>
        <span className={className ? className : ""}>{checkoutText ? checkoutText : "Checkout now"}</span>
      </button>
      </>
      )}
      {/* No link on button */}
      {!href && (
        <button className={`btn-primary ${styles.checkout_btn} ${isOnlyOOS ? 'disabled' : ''}`}>
          <span className={className ? className : ""}>{checkoutText ? checkoutText : "Checkout now"}</span>
        </button>
      )}
      {showPaymentIcons&&<InstallmentMsg showLogo={true} hasClass={"bag-basket"} />}
    </>
  );
}